// defaultContent.js — All default site content, used as fallback when localStorage is empty

export const DEFAULT_CONTENT = {
  logo: {
    text: "WebStudio",
    imageUrl: null,
    imageDarkUrl: null,
  },
  hero: {
    title: "Beautiful Websites That Convert",
    titleEs: "Sitios Web Hermosos que Convierten",
    subtitle: "Fast, modern, and responsive web design tailored to your business — built to impress and built to grow.",
    subtitleEs: "Diseño web rápido, moderno y responsive adaptado a tu negocio — creado para impresionar y para crecer.",
    ctaText: "Start Your Project",
    ctaTextEs: "Inicia Tu Proyecto",
    ctaLink: "#contact",
    bgImage: "https://images.unsplash.com/photo-1467232004584-a241de8bcf5d?w=1920&q=80",
    viewWorkText: "View Our Work ↓",
    viewWorkTextEs: "Ver Nuestro Trabajo ↓",
  },
  splitSection: {
    badge: "Design & Development",
    badgeEs: "Diseño y Desarrollo",
    heading: "UI/UX Design & Frontend Development in Spain",
    headingEs: "Diseño UI/UX y Desarrollo Frontend en España",
    paragraph1: "I design and build modern, high-performance websites and digital products from concept to launch. As a UI/UX designer and frontend developer, I combine user-centered design with clean, scalable code to deliver fast, responsive, and conversion-focused web experiences.",
    paragraph1Es: "Diseño y desarrollo sitios web modernos y de alto rendimiento desde el concepto hasta el lanzamiento. Como diseñador UI/UX y desarrollador frontend, combino el diseño centrado en el usuario con código limpio y escalable para crear experiencias web rápidas, responsive y orientadas a la conversión.",
    paragraph2: "From research and wireframes to high-fidelity UI design and React-based frontend development, every project is built with usability, performance, and SEO best practices in mind. I create mobile-first business websites and digital interfaces that strengthen brand identity and improve user engagement.",
    paragraph2Es: "Desde la investigación y los wireframes hasta el diseño UI de alta fidelidad y el desarrollo frontend con React, cada proyecto se construye teniendo en cuenta la usabilidad, el rendimiento y las mejores prácticas de SEO. Creo sitios web empresariales mobile-first e interfaces digitales que refuerzan la identidad de marca y mejoran el engagement.",
    paragraph3: "Whether you need a landing page, a corporate website, or a custom frontend solution, I provide end-to-end digital services tailored to your business goals.",
    paragraph3Es: "Ya sea que necesites una landing page, un sitio web corporativo o una solución frontend personalizada, ofrezco servicios digitales integrales adaptados a los objetivos de tu negocio.",
    image: "https://images.unsplash.com/photo-1551650975-87deedd944c3?w=900&q=80",
    imageAlt: "UI/UX Design and Frontend Development workspace",
  },
  services: [
    {
      id: "svc1",
      icon: "🚀",
      title: "Landing Page",
      titleEs: "Landing Page",
      description: "Fast, modern, responsive one-page website engineered for maximum conversions.",
      descriptionEs: "Sitio web de una página rápido, moderno y responsive diseñado para máximas conversiones.",
      subServices: ["Custom design", "Mobile-friendly", "Lead capture form", "SEO optimized"],
      subServicesEs: ["Diseño personalizado", "Compatible con móviles", "Formulario de captación", "SEO optimizado"],
    },
    {
      id: "svc2",
      icon: "🏢",
      title: "Business Website",
      titleEs: "Sitio Web Empresarial",
      description: "Multi-page professional website that establishes your authority and presence.",
      descriptionEs: "Sitio web profesional de múltiples páginas que establece tu autoridad y presencia online.",
      subServices: ["About, Services, Contact pages", "Image galleries", "Blog-ready", "SEO-friendly"],
      subServicesEs: ["Páginas Sobre, Servicios, Contacto", "Galerías de imágenes", "Listo para blog", "SEO-friendly"],
    },
    {
      id: "svc3",
      icon: "✨",
      title: "Website Redesign",
      titleEs: "Rediseño Web",
      description: "Transform your outdated site into a modern, high-performance digital experience.",
      descriptionEs: "Transforma tu sitio obsoleto en una experiencia digital moderna y de alto rendimiento.",
      subServices: ["UI/UX improvements", "Faster loading", "Updated branding", "Mobile optimization"],
      subServicesEs: ["Mejoras UI/UX", "Carga más rápida", "Branding actualizado", "Optimización móvil"],
    },
    {
      id: "svc4",
      icon: "📅",
      title: "Booking & Reservation",
      titleEs: "Reservas y Citas",
      description: "Let customers book appointments and events directly online — 24/7.",
      descriptionEs: "Permite que los clientes reserven citas y eventos directamente online — 24/7.",
      subServices: ["Online booking form", "Calendar integration", "Email notifications", "Payment links"],
      subServicesEs: ["Formulario de reserva online", "Integración de calendario", "Notificaciones por email", "Links de pago"],
    },
    {
      id: "svc5",
      icon: "📬",
      title: "Contact Forms & Lead Collection",
      titleEs: "Formularios y Captación de Leads",
      description: "Turn website visitors into real leads with smart, validated contact forms.",
      descriptionEs: "Convierte visitantes en clientes potenciales con formularios de contacto inteligentes y validados.",
      subServices: ["Email/Google Sheets integration", "Responsive design", "Spam protection", "Validation"],
      subServicesEs: ["Integración Email/Google Sheets", "Diseño responsive", "Protección anti-spam", "Validación"],
    },
    {
      id: "svc6",
      icon: "💳",
      title: "Payment Integration",
      titleEs: "Integración de Pagos",
      description: "Accept payments online without a complex backend — simple and secure.",
      descriptionEs: "Acepta pagos online sin un backend complejo — simple y seguro.",
      subServices: ["Stripe/PayPal link buttons", "Secure checkout", "Easy integration", "Receipt automation"],
      subServicesEs: ["Botones Stripe/PayPal", "Pago seguro", "Integración sencilla", "Automatización de recibos"],
    },
  ],
  servicesMobileSwiper: true,

  portfolio: {
    numberOfCardsToShow: 3,
    partialCardVisiblePercent: 35,
    projects: [
      {
        id: "p1",
        title: "Luminary Spa",
        titleEs: "Luminary Spa",
        thumbnail: "",
        category: "Landing Page",
        categoryEs: "Landing Page",
        description: "Elegant spa landing page with booking form, gallery, and service showcase.",
        descriptionEs: "Elegante landing page para spa con formulario de reserva, galería y presentación de servicios.",
        images: [
          {
            desktop: "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=800&q=80",
            mobile: "https://images.unsplash.com/photo-1519824145371-296894a0daa9?w=800&q=80",
            alt: "Luminary Spa homepage desktop and mobile view",
          },
          {
            desktop: "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800&q=80",
            mobile: "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800&q=80",
            alt: "Luminary Spa services section",
          },
        ],
      },
      {
        id: "p2",
        title: "Apex Consulting",
        titleEs: "Apex Consulting",
        thumbnail: "",
        category: "Business Website",
        categoryEs: "Sitio Web Empresarial",
        description: "Authoritative multi-page site for a management consulting firm.",
        descriptionEs: "Sitio de múltiples páginas para una firma de consultoría de gestión empresarial.",
        images: [
          {
            desktop: "https://images.unsplash.com/photo-1497366216548-37526070297c?w=800&q=80",
            mobile: "https://images.unsplash.com/photo-1553877522-43269d4ea984?w=800&q=80",
            alt: "Apex Consulting homepage",
          },
        ],
      },
      {
        id: "p3",
        title: "FreshBites Catering",
        titleEs: "FreshBites Catering",
        thumbnail: "",
        category: "Booking & Reservation",
        categoryEs: "Reservas y Citas",
        description: "Food catering service with event booking, menu showcase, and inquiry forms.",
        descriptionEs: "Servicio de catering con reserva de eventos, presentación del menú y formularios de consulta.",
        images: [
          {
            desktop: "https://images.unsplash.com/photo-1555244162-803834f70033?w=800&q=80",
            mobile: "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=800&q=80",
            alt: "FreshBites Catering homepage",
          },
        ],
      },
      {
        id: "p4",
        title: "TechFlow SaaS",
        titleEs: "TechFlow SaaS",
        thumbnail: "",
        category: "Website Redesign",
        categoryEs: "Rediseño Web",
        description: "Complete visual and performance overhaul of a SaaS marketing site.",
        descriptionEs: "Renovación visual y de rendimiento completa de un sitio de marketing SaaS.",
        images: [
          {
            desktop: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&q=80",
            mobile: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80",
            alt: "TechFlow SaaS redesigned homepage",
          },
        ],
      },
      {
        id: "p5",
        title: "Artisan Coffee Co.",
        titleEs: "Artisan Coffee Co.",
        thumbnail: "",
        category: "Landing Page",
        categoryEs: "Landing Page",
        description: "Specialty coffee brand with story-driven design and online shop integration.",
        descriptionEs: "Marca de café especial con diseño narrativo e integración de tienda online.",
        images: [
          {
            desktop: "https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?w=800&q=80",
            mobile: "https://images.unsplash.com/photo-1509042239860-f550ce710b93?w=800&q=80",
            alt: "Artisan Coffee Co. landing page",
          },
        ],
      },
    ],
  },
  pricing: {
    numberOfTiersToShow: 3,
    tiers: [
      {
        id: "tier1",
        name: "Starter",
        nameEs: "Básico",
        price: "€499",
        originalPrice: "",
        recommended: false,
        bullets: [
          "Landing page (1 page)",
          "Mobile responsive design",
          "Contact form included",
          "2 rounds of revisions",
          "Delivered in 5 days",
          "Basic SEO setup",
        ],
        bulletsEs: [
          "Landing page (1 página)",
          "Diseño responsive para móvil",
          "Formulario de contacto incluido",
          "2 rondas de revisiones",
          "Entregado en 5 días",
          "Configuración básica de SEO",
        ],
      },
      {
        id: "tier2",
        name: "Growth",
        nameEs: "Crecimiento",
        price: "€999",
        originalPrice: "",
        recommended: true,
        bullets: [
          "Up to 5 pages",
          "Custom design system",
          "SEO optimized",
          "Booking or payment integration",
          "5 rounds of revisions",
          "Analytics setup",
          "Delivered in 10 days",
        ],
        bulletsEs: [
          "Hasta 5 páginas",
          "Sistema de diseño personalizado",
          "SEO optimizado",
          "Integración de reservas o pagos",
          "5 rondas de revisiones",
          "Configuración de Analytics",
          "Entregado en 10 días",
        ],
      },
      {
        id: "tier3",
        name: "Pro",
        nameEs: "Pro",
        price: "€1,799",
        originalPrice: "",
        recommended: false,
        bullets: [
          "Up to 10 pages",
          "Full custom design + brand system",
          "Advanced integrations",
          "Google Sheets / CRM sync",
          "Unlimited revisions",
          "Priority support",
          "Performance audit",
          "Delivered in 21 days",
        ],
        bulletsEs: [
          "Hasta 10 páginas",
          "Diseño personalizado + sistema de marca",
          "Integraciones avanzadas",
          "Sincronización Google Sheets / CRM",
          "Revisiones ilimitadas",
          "Soporte prioritario",
          "Auditoría de rendimiento",
          "Entregado en 21 días",
        ],
      },
    ],
  },
  testimonials: [
    {
      id: "t1",
      text: "Working with WebStudio was an absolute pleasure. They delivered a stunning website that doubled our leads within the first month.",
      textEs: "Trabajar con WebStudio fue un placer absoluto. Entregaron un sitio web impresionante que duplicó nuestros clientes potenciales en el primer mes.",
      author: "María García",
      role: "CEO, Luminary Spa",
      roleEs: "CEO, Luminary Spa",
      avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&q=80",
    },
    {
      id: "t2",
      text: "Professional, fast, and the result exceeded every expectation. Our new site perfectly represents who we are.",
      textEs: "Profesional, rápido y el resultado superó todas las expectativas. Nuestro nuevo sitio nos representa a la perfección.",
      author: "James Wilson",
      role: "Director, Apex Consulting",
      roleEs: "Director, Apex Consulting",
      avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&q=80",
    },
    {
      id: "t3",
      text: "The booking system they built has saved us hours every week. Clients love how easy it is to schedule with us now.",
      textEs: "El sistema de reservas que construyeron nos ha ahorrado horas cada semana. A los clientes les encanta lo fácil que es reservar con nosotros ahora.",
      author: "Sofía Martínez",
      role: "Owner, FreshBites Catering",
      roleEs: "Propietaria, FreshBites Catering",
      avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&q=80",
    },
  ],
  cta: {
    title: "Ready to Build Your Dream Website?",
    titleEs: "¿Listo para Crear el Sitio Web de tus Sueños?",
    subtitle: "Join dozens of businesses who've grown their online presence with us.",
    subtitleEs: "Únete a decenas de empresas que han hecho crecer su presencia online con nosotros.",
    buttonText: "Start Your Project",
    buttonTextEs: "Inicia Tu Proyecto",
    link: "#contact",
  },
  contact: {
    title: "Let's Work Together",
    titleEs: "Trabajemos Juntos",
    subtitle: "Reach out and let's start building something great.",
    subtitleEs: "Contáctanos y empecemos a construir algo increíble.",
    email: "hello@webstudio.dev",
    whatsapp: "+34 600 000 000",
    namePlaceholder: "Your name",
    namePlaceholderEs: "Tu nombre",
    emailPlaceholder: "Your email address",
    emailPlaceholderEs: "Tu dirección de email",
    messagePlaceholder: "Tell us about your project...",
    messagePlaceholderEs: "Cuéntanos sobre tu proyecto...",
    sendButtonText: "Send Message",
    sendButtonTextEs: "Enviar Mensaje",
  },
  footer: {
    brand: "WebStudio",
    tagline: "Building the web, one pixel at a time.",
    taglineEs: "Construyendo la web, un píxel a la vez.",
    copyright: "© 2025 WebStudio. All rights reserved.",
  },
  cloudinary: {
    cloudName: "",
    uploadPreset: "",
  },
  techStack: {
    enabled: true,
    sectionTitle: "Tech Stack",
    sectionTitleEs: "Tecnologías",
    sectionSubtitle: "The technologies and tools I use to design and build modern web experiences.",
    sectionSubtitleEs: "Las tecnologías y herramientas que utilizo para diseñar y desarrollar experiencias web modernas.",
    items: [
      { id: "ts1",  name: "HTML5",          category: "Frontend", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg" },
      { id: "ts2",  name: "CSS3",           category: "Frontend", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg" },
      { id: "ts3",  name: "JavaScript",     category: "Frontend", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg" },
      { id: "ts4",  name: "React",          category: "Frontend", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg" },
      { id: "ts5",  name: "Tailwind CSS",   category: "Frontend", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/tailwindcss/tailwindcss-original.svg" },
      { id: "ts6",  name: "Figma",          category: "Design",   logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/figma/figma-original.svg" },
      { id: "ts7",  name: "UI/UX Design",   category: "Design",   logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/sketch/sketch-original.svg" },
      { id: "ts8",  name: "Design Systems", category: "Design",   logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/storybook/storybook-original.svg" },
      { id: "ts9",  name: "Git",            category: "Tools",    logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg" },
      { id: "ts10", name: "GitHub",         category: "Tools",    logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/github/github-original.svg" },
      { id: "ts11", name: "Firebase",       category: "Tools",    logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/firebase/firebase-plain.svg" },
      { id: "ts12", name: "Vercel",         category: "Tools",    logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vercel/vercel-original.svg" },
      { id: "ts13", name: "SEO",            category: "Tools",    logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/google/google-original.svg" },
    ],
  },
  whatsapp: {
    enabled: false,
    phone: "",
    message: "Hello! I'm interested in your web design services.",
    label: "Chat on WhatsApp",
  },
  seo: {
    // Títulos: máx 60 caracteres, keyword principal al inicio
    titleEn: "Webilo — Web Design & Frontend Development in Spain",
    titleEs: "Webilo — Diseño Web y Desarrollo Frontend en España",

    // Descripciones: máx 155 caracteres, incluye keyword + CTA
    descriptionEn: "Webilo offers professional web design, UI/UX and React frontend development in Spain. Modern, fast, SEO-optimized websites for businesses and freelancers.",
    descriptionEs: "Webilo ofrece diseño web profesional, UI/UX y desarrollo frontend con React en España. Sitios modernos, rápidos y optimizados para SEO para empresas y autónomos.",

    // Keywords expandidas: short-tail + long-tail + local
    keywordsEn: "web design Spain, frontend developer Spain, React developer Spain, UI UX design Spain, responsive web design, SEO optimization, landing page design, business website Spain, web design agency Spain, hire web designer Spain, freelance web developer Spain, Webilo",
    keywordsEs: "diseño web España, desarrollador frontend España, diseño UI UX España, página web empresas España, diseño web responsive, optimización SEO, diseño landing page, agencia diseño web España, contratar diseñador web España, freelance desarrollador web España, desarrollo React España, Webilo",

    ogImage: "https://www.webilo.es/og-image.jpg",
  },
  sectionBg: {
    portfolio: false,
    pricing: false,
    contact: false,
  },
};
